module.exports = __webpack_public_path__ + "072d1eca8b82ae6fb3316353274db1e8.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/app-store-apple.png
// module id = 3560
// module chunks = 25